export default class DashChart {
  constructor({ submittedcount, pendingcount, checklistName }) {
    this.submittedcount = submittedcount || '';
    this.pendingcount = pendingcount || '';
    this.checklistName = checklistName || '';
  }
}
